import request from '@/utils/request'

/**
 *修改仓库地址
 * @param {*} data 
 */
export function updateStore(data){
    return request({
        url: '/common/updateStore',
        method: 'post',
        data
    })
}
/**
 *十六、获取仓库
 * @param {*} data 
 */
export function getStore(data){
    return request({
        url: '/common/getStore',
        method: 'post',
        data
    })
}

/**
 *货运列表
 * @param {*} data 
 */
 export function getStoreList(data){
    return request({
        url: '/store/list',
        method: 'post',
        data
    })
}

/**
 *货运添加
 * @param {*} data 
 */
 export function storeAdd(data){
    return request({
        url: '/store/add',
        method: 'post',
        data
    })
}

/**
 *货运修改
 * @param {*} data 
 */
 export function storeUpdate(data){
    return request({
        url: '/store/update',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/address.js